/**
 * @module productUnits
 * @description A list of productUnits
 */

export const productUnits = [
	'Nos',
	'Hour',
	'Unit',
	'lbs',
	'Kg',
	'Metre',
	'MM',
] as const;
export type ProductUnits = (typeof productUnits)[number];
